import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogBox({ open, handleClose, data, successMessage }: any) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm" 
        fullWidth 
      >
        {successMessage}
        {data?.map((item : any, index: number) => {
          return (
            <React.Fragment key={index}>
              <DialogTitle
                id="alert-dialog-title"
                sx={{
                  color: "red",
                }}
              >
                {item?.awb}
              </DialogTitle>
              <DialogContent
              >
                <DialogContentText
                  sx={{
                    color: "red",
                  }}
                  id="alert-dialog-description"
                >
                  {item?.reason}
                </DialogContentText>
              </DialogContent>
            </React.Fragment>
          );
        })}

        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
